<template>
  <div class="ding-comingSoon">
    <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/await@2x.png" alt="">
    <div class="comingSoon-hint">即将推出 敬请期待</div>
    <div class="comingSoon-hint2"><span @click="toPath('/dingWorkbench')">{{"<< 返回首页"}}</span></div>
  </div>
</template>
<script>
  export default {
    props: [],
    data () {
      
      return {
        
      }
    },
    components: {
      
    },
    created () {
      
    },
    mounted () {

    },
    methods: {
      
      toPath(url){
        this.$router.push(url)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/dingWorkbench/comingSoon.vue